// src/config/backend.ts
const isLocalDev =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.port === "5173"; // ← ADD THIS

export const BACKEND_URL = isLocalDev
  ? "http://localhost:8000"
  : "https://159.89.248.55.nip.io";

// console.log(
//   "🔧 BACKEND_URL:",
//   BACKEND_URL,
//   "| hostname:",
//   window.location.hostname,
//   "| port:",
//   window.location.port
// );
